import { useState } from 'react';
import { ShieldCheck, KeyRound } from 'lucide-react';
import { normalizeApiError } from '../utils/validate';
import { useLanguage } from '../i18n/LanguageContext';

export default function FirstLoginPage({ session, api, onComplete }) {
  const { t } = useLanguage();
  const [newPassword, setNewPassword]         = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError]                     = useState('');
  const [saving, setSaving]                   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword)                    { setError('New password is required.'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match.'); return; }
    setError('');
    setSaving(true);
    try {
      await api.users.changePassword({
        userId:      session.user.id,
        oldPassword: session.rawPassword,
        newPassword,
      }, session.token);

      // Activate user account (statusId 2 = Active). Account state lives on the
      // user only — a driver's own status is independent of whether they have a
      // login, so nothing on the driver record is touched here.
      await api.users.updateUserStatus(session.user.id, 2, session.token);

      onComplete(
        {
          id:             session.user.id,
          fullName:       session.user.username,
          email:          '',
          username:       session.user.username,
          phone:          '',
          role:           'user',
          department:     'Operations',
          status:         'active',
          organizationId: session.user.organizationId,
          companyName:    '',
          lastLoginAt:    new Date().toISOString(),
        },
        session.token,
      );
    } catch (e) {
      setError(normalizeApiError(e, 'update password').message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-panel">
        <div className="auth-brand-band">
          <div className="auth-brand-copy">
            <div className="auth-badge">
              <ShieldCheck size={20} />
            </div>
            <div>
              <div className="auth-kicker">{t('secureAccess')}</div>
              <h1>{t('fleetMgmtSystem')}</h1>
              <p>{t('smartFleet')}</p>
            </div>
          </div>
        </div>

        <div className="auth-card">
          <form className="auth-form" onSubmit={handleSubmit}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
              <KeyRound size={20} style={{ color: 'var(--text-accent)', flexShrink: 0 }} />
              <div className="section-title" style={{ margin: 0 }}>{t('setYourPassword')}</div>
            </div>
            <div className="section-subtitle" style={{ marginBottom: 20 }}>
              {t('firstLoginSubtitle')}
            </div>

            <div className="form-group">
              <label>{t('newPassword')}</label>
              <input
                type="password"
                value={newPassword}
                onChange={e => { setNewPassword(e.target.value); if (error) setError(''); }}
                placeholder={t('enterNewPassword')}
                autoFocus
              />
            </div>
            <div className="form-group">
              <label>{t('confirmPassword')}</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={e => { setConfirmPassword(e.target.value); if (error) setError(''); }}
                placeholder={t('reEnterNewPassword')}
              />
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button className="btn btn-primary auth-submit" type="submit" disabled={saving}>
              {saving ? t('saving') : t('setPasswordContinue')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
